import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRequisitionPartialWorkflowFields {
		id?: any;
		requisitionPartialId?: any;
		workflowId?: any;
		datestamp?: any;
		userId?: any;
		comments?: any;
}

export class RequisitionPartialWorkflowFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public requisitionPartialId: IEntityModelField = { name: "requisitionPartialId", displayName: "Requisition Partial Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public workflowId: IEntityModelField = { name: "workflowId", displayName: "Workflow Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public userId: IEntityModelField = { name: "userId", displayName: "User Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public comments: IEntityModelField = { name: "comments", displayName: "Comments", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionPartialId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionPartialWorkflowDTO implements IEntityModel {
	protected requisitionPartialWorkflowName: string = "RequisitionPartialWorkflowModel";
	protected requisitionPartialWorkflowKeyField: string = "id";
	protected requisitionPartialWorkflowDisplayName: string = "Requisition Partial Workflow|Requisition Partial Workflows";
	protected requisitionPartialWorkflowFields = new RequisitionPartialWorkflowFields();
	public get name(): string { return this.requisitionPartialWorkflowName };
	public get keyField(): string { return this.requisitionPartialWorkflowKeyField };
	public get displayName(): string { return this.requisitionPartialWorkflowDisplayName };
	public get fields(): RequisitionPartialWorkflowFields { return this.requisitionPartialWorkflowFields };

	constructor() {};
}
